import {
  createAction,
  createReducer,
} from '@reduxjs/toolkit';

import {
  EDrawerMenu,
} from '@noitada/shared/enums';



const INITIAL_STATE = {
  menuSelected: EDrawerMenu.HOME,

  drawer: false,
  modalLoading: false,
  snackBar: {
    visible: false,
    color: null,
    text: null,
  },

  // modalLocationApp: false,
  // modalLocationCarnival: false,
};



// Action Types

export const APP_MENU_SELECTED_ACTION = '@user/MENU_SELECTED_ACTION';

export const APP_DRAWER_ACTION = '@user/DRAWER_ACTION';
export const APP_SNACKBAR_ACTION = '@user/SNACKBAR_ACTION';
export const APP_SNACKBAR_RESET = '@company/SNACKBAR_RESERT';
export const APP_RESET_APP = '@company/RESET_APP';

export const APP_MODAL_LOADING_ACTION = '@company/MODAL_LOADING_ACTION';
// export const MODAL_LOCATION_APP_ACTION = '@company/MODAL_LOCATION_APP_ACTION';
// export const MODAL_LOCATION_CARNIVAL_ACTION = '@company/MODAL_LOCATION_CARNIVAL_ACTION';



// Action Creators

export const menuSelectedAction = createAction<object>(APP_MENU_SELECTED_ACTION);

export const drawerAction = createAction<object>(APP_DRAWER_ACTION);
export const snackbarAction = createAction<object>(APP_SNACKBAR_ACTION);
export const snackbarResetAction = createAction<object>(APP_SNACKBAR_RESET);
export const resetAppAction = createAction<object>(APP_RESET_APP);

export const modalLoadingAction = createAction<object>(APP_MODAL_LOADING_ACTION);
// export const modalLocationAppAction = createAction<object>(MODAL_LOCATION_APP_ACTION);
// export const modalLocationCarnivalAction = createAction<object>(MODAL_LOCATION_CARNIVAL_ACTION);



// Handlers

const menuSelectedReducer = (state = INITIAL_STATE, action: any) => ({
  ...state,
  menuSelected: action.payload,
});


const drawerReducer = (state = INITIAL_STATE, action) => ({
  ...state,
  drawer: action.payload,
});


const snackbarReducer = (state = INITIAL_STATE, action: any) => ({
  ...state,
  snackBar: action.payload,
});


const snackbarResetReducer = (state = INITIAL_STATE) => ({
  ...state,
  snackBar: INITIAL_STATE.snackBar,
});


const resetAppStates = () => ({
  ...INITIAL_STATE,
});



const modalLoadingReducer = (state = INITIAL_STATE, action: any) => ({
  ...state,
  modalLoading: action.payload,
});


// const modalLocationAppReducer = (state = INITIAL_STATE, action: any) => ({
//   ...state,
//   modalLocationApp: action.payload,
// });


// const modalLocationCarnivalReducer = (state = INITIAL_STATE, action: any) => ({
//   ...state,
//   modalLocationCarnival: action.payload,
// });



// Reducers

export default createReducer(INITIAL_STATE, {
  [menuSelectedAction.type]: menuSelectedReducer,
  [drawerAction.type]: drawerReducer,
  [snackbarAction.type]: snackbarReducer,
  [snackbarResetAction.type]: snackbarResetReducer,
  [resetAppAction.type]: resetAppStates,

  [modalLoadingAction.type]: modalLoadingReducer,
  // [modalLocationAppAction.type]: modalLocationAppReducer,
  // [modalLocationCarnivalAction.type]: modalLocationCarnivalReducer,
});
